export default {
  platformId: "crossboundary",
  mainLogo: "media/logos/prosper-logo-fit.svg",
  lightLogo: "media/logos/prosper-logo.svg",
  dealSearchId: "crossboundary_pa",
  appTitle: "Prosper Africa VDR",
  enabledAd: true,
  filters: [
    "industrySectors",
    "dealRanges",
    "regionalFocus",
    "dealStructure",
    "investingThemes",
    "sector",
  ],
};
